import ReactDOM from 'react-dom'
import React from 'react'

import RegisterScreen from './RegisterScreen'
import ProfileScreen from './ProfileScreen'
import LeaderboardScreen from './LeaderboardScreen'
import SimpleMessageScreen from './SimpleMessageScreen'
import ActorSession from './ActorSession'
import ActorSessionHistory from './ActorSessionHistory'
import ActorHome from './ActorHome'
import ActorAdmin from './ActorAdmin'
import BotSession from './BotSession'
import SubmitSessionSpec from './SubmitSessionSpec'
import SubmitBotSession from './SubmitBotSession'
import SubmitTaskSpec from './SubmitTaskSpec'
import PageWrapper from './PageWrapper'
import FAQ from './FAQ'
import WelcomeScreen from './WelcomeScreen'
import AdminHome from './AdminHome'
import AdminManageUsers from './AdminManageUsers'
import SlackAdmin from './SlackAdmin'
import DaynaHome from './DaynaHome'
import DaynaViewScript from './DaynaViewScript'
import DaynaGenerateScript from './DaynaGenerateScript'
import ModelDashboard from './ModelDashboard'


export {
  RegisterScreen,
  ProfileScreen,
  LeaderboardScreen,
  SimpleMessageScreen,
  ActorSession,
  ActorSessionHistory,
  ActorHome,
  ActorAdmin,
  BotSession,
  SubmitSessionSpec,
  SubmitBotSession,
  SubmitTaskSpec,
  FAQ,
  WelcomeScreen,
  AdminHome,
  AdminManageUsers,
  SlackAdmin,
  PageWrapper, 
  DaynaHome, 
  DaynaViewScript, 
  DaynaGenerateScript,
  ModelDashboard,
}

global.mixer = require('./index')
global.React = require('react')
global.ReactDOM = require('react-dom')
